import TransactionSummary from "./TransactionSummary";

const PayoutPendingSummary = () => {
    return (
        <div className="payout-pending-summary">
          <TransactionSummary/>
        </div>
    );
}
export default PayoutPendingSummary;